<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { getAwsConfig } from "neuron-apollo-common";
import { mapState, mapGetters } from "vuex";
// import API_CONFIG from "./apiConfig";

const loginPath = {
  login: "login",
  userManagement: "userManagement",
  userInfo: "userInfo",
  resetPassword: "resetPassword",
};
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {
    ...mapState(["AWS_CONFIG"]),
    ...mapGetters({
      theme: "app/getTheme",
      language: "app/getLanguage",
    }),
  },
  methods: {
    init() {
      this.checkpathList();
    },
    async checkpathList() {
      this.loading = true;
      const pathList = loginPath;
      const language = this.$route.query.language || "en";

      let theme = this.$route.query.theme || "dark";
      const isInvite = this.$route.query.isInvite || false;

      if (theme === undefined || theme === "undefined") {
        theme = "dark";
      }
      const params = `isInvite=${isInvite}&isUnneedGroup=true&language=${language}&theme=${theme}`;
      const paths = {};
      Object.keys(pathList).forEach((k) => {
        let path = "";
        if (k === "userInfo") {
          path = "userinfo";
        } else if (k !== "login") {
          path = k;
        }
        paths[k] = `/login/#/${path}?${params}`;
      });
      this.$store.dispatch("updateAwsConfigItem", {
        key: "pathList",
        subKey: "paths",
        val: paths,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less">
body {
  font-family: "Noto Sans SC" !important;
}
</style>
